import classNames from "classnames/bind";
import styles from "./FeaturedPerson.module.css";

const cx = classNames.bind(styles);

interface FeaturedPersonProps {
  name?: string | null;
  jobTitle?: string | null;
  image?: {
    src: string;
    alt: string;
  };
  className?: string;
}

export const FeaturedPerson = ({
  name,
  jobTitle,
  image,
  className,
}: FeaturedPersonProps) => {
  if (!name && !jobTitle && !image) {
    return null;
  }

  return (
    <div className={cx("root", className)}>
      {image ? (
        <img src={image.src} alt={image.alt} className={cx("image")} />
      ) : null}
      <div className={cx("content")}>
        {name ? <div className={cx("name")}>{name}</div> : null}
        {jobTitle ? <div className={cx("job-title")}>{jobTitle}</div> : null}
      </div>
    </div>
  );
};
